var main = function(){
	var swatches_cart = $('.order-swatches-cart')
	
	$(document).scroll(function(){
		if ( $(this).scrollTop() >= $(window).height() - swatches_cart.height() + 400 ){
		swatches_cart.removeClass('is-sticky');
		} else {
		swatches_cart.addClass('is-sticky');
		}
	})
}

var main_mobile = function(){
	var swatches_cart = $('.order-swatches-cart')
	
	$(document).scroll(function(){
		if ( $(this).scrollTop() >= $(window).height() - swatches_cart.height() + 3500 ){
		swatches_cart.removeClass('is-sticky');
		} else {
		swatches_cart.addClass('is-sticky');
		}
	})
}

var pageWidth = $(window).width();
if (pageWidth > 1024) {
$(document).ready(main); 
} else { $(document).ready(main_mobile);  }


$(document).ready(function(){
  $(".swatch-items .swatch-image:not(.main_image)").click(function(){
  	var parent_id = $(this).parent().parent().attr('id');
    var data_swatch_color = $(this).parent().parent().parent().attr("data-swatch-name");
    var data_swatch_category = $(this).parent().parent().parent().attr("data-swatch-category");
    var img_url = $(this).find('img').attr('src');
    var data_drop = $('.swatch-block.is-empty:first');
    var vari_price = $(this).data('variant-price');
    
    //alert(parent_id);
    
    if ($(this).parent().parent().hasClass('selected')) {
      $('#s-'+parent_id).find('img').attr('src', "//www.luxusbeds.co.uk/cdn/shop/t/40/assets/empty-slot-swatches_121x121.png?v=90203678626189354381737821548");
      $('#s-'+parent_id).addClass('is-empty');
      $('#s-'+parent_id).removeClass('not-empty');
      $('#s-'+parent_id).find('.swatch-name').text('');
      $(this).parent().parent().removeClass('selected');
    }
    
    else {
    
      if($('.is-empty').length) {
      $(this).parent().parent().addClass('selected');
      data_drop.attr('id', 's-' + parent_id);
      data_drop.attr('data-vPrice',vari_price);
      data_drop.addClass('not-empty');
      data_drop.attr('data-swatch-name', data_swatch_color );
      data_drop.attr('data-swatch-category', data_swatch_category );
      data_drop.find(".swatch-name").text(data_swatch_category + ' ' +data_swatch_color);
      data_drop.find('img').attr('src', img_url);
      $('.swatch-block.is-empty:first').removeClass('is-empty');  
      
        
        
      }
    
    }
    
    
    
  });
});

$(document).ready(function(){
  $('.swatch-cart-items .swatch-cart-items-inner .swatch-image:not(.cart_image)').click(function(){
    
    var block_id = $(this).parent().parent().parent().attr('id').replace('s-','');
    
  	$(this).find('img').attr('src', "//www.luxusbeds.co.uk/cdn/shop/t/40/assets/empty-slot-swatches_121x121.png?v=90203678626189354381737821548");
    $(this).parent().parent().parent().addClass('is-empty');
    $(this).parent().parent().parent().removeClass('not-empty');
    $(this).parent().find('.swatch-name').text('');
    $('#'+block_id).removeClass('selected');
  });
  
  
  
});


$(document).ready(function(){
window.setInterval(function(){
  if($('.swatch-block.is-empty').length){ $('.order-swatches-section .swatch-block').removeClass('disabled'); } else { $('.order-swatches-section .swatch-block').addClass('disabled'); }
}, 100);
});

function isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}

var error = 0;


$('.order-swatches-form-block input').blur(function()
{
    if( !$(this).val() ) {
      	  $(this).addClass('warning');
          $(this).next('.required-field').addClass('visible-error');
      	  
    }
  else {
    $(this).removeClass('warning');
  	$(this).next('.required-field').removeClass('visible-error');
  }
});

$('.order-swatches-form-block input[type="email"]').blur(function() {
  var email_value = $(this).val();
  if (isEmail(email_value)) {
    $(this).next().next('.email-field').removeClass('visible-error');
    $(this).removeClass('warning');
    
  }
  else { 
  	$(this).next().next('.email-field').addClass('visible-error');
    $(this).addClass('warning');
  }
});


$('.order-swatch-checkbox label').click(function(){
	$(this).toggleClass('active');
  	$('#ContactFormNewsletter').click();
    /*var accept_marketing = $('#accept_marketing').val();
    if (accept_marketing == 'true') { 
    	$('#accept_marketing').val('false');
    } else { $('#accept_marketing').val('true'); }*/
});



$('#order_swatches_main_form').submit(function() {
 
  
  
  var swatch_data_1_color = $('.swatch__1').attr("data-swatch-name");
  var swatch_data_2_color = $('.swatch__2').attr("data-swatch-name");
  var swatch_data_3_color = $('.swatch__3').attr("data-swatch-name");
  var swatch_data_4_color = $('.swatch__4').attr("data-swatch-name");
  var swatch_data_5_color = $('.swatch__5').attr("data-swatch-name");
  var swatch_data_6_color = $('.swatch__6').attr("data-swatch-name");
  var swatch_data_7_color = $('.swatch__7').attr("data-swatch-name");
  var swatch_data_8_color = $('.swatch__8').attr("data-swatch-name");
  
  var swatch_data_1_category = $('.swatch__1').attr("data-swatch-category");
  var swatch_data_2_category = $('.swatch__2').attr("data-swatch-category");
  var swatch_data_3_category = $('.swatch__3').attr("data-swatch-category");
  var swatch_data_4_category = $('.swatch__4').attr("data-swatch-category");
  var swatch_data_5_category = $('.swatch__5').attr("data-swatch-category");
  var swatch_data_6_category = $('.swatch__6').attr("data-swatch-category");
  var swatch_data_7_category = $('.swatch__7').attr("data-swatch-category");
  var swatch_data_8_category = $('.swatch__8').attr("data-swatch-category");
  
  $('#contentSwatch1').val(swatch_data_1_category + ' ' + swatch_data_1_color);
  $('#contentSwatch2').val(swatch_data_2_category + ' ' + swatch_data_2_color);
  $('#contentSwatch3').val(swatch_data_3_category + ' ' + swatch_data_3_color);
  $('#contentSwatch4').val(swatch_data_4_category + ' ' + swatch_data_4_color);
  $('#contentSwatch5').val(swatch_data_5_category + ' ' + swatch_data_5_color);
  $('#contentSwatch6').val(swatch_data_6_category + ' ' + swatch_data_6_color);
  $('#contentSwatch7').val(swatch_data_7_category + ' ' + swatch_data_7_color);
  $('#contentSwatch8').val(swatch_data_8_category + ' ' + swatch_data_8_color);
  
  
  if($('.not-empty').length){} else { $('#swatch_indicator').css({ 'display': 'block' }); return false;  }
  
  
});

